<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Daftar Void Gadai</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="12" xl="6">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDate" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterToDate" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="12" xl="6">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                                <multiselect
                                class="ml-0"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterVoidStatus" label="Void Status">
                            <b-form-select v-model="input.filterVoidStatus" id="filterVoidStatus" name="voidStatus" :options="voidStatus" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Void Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="daftarGadai" 
                :fields="fields" 
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{ row.item.noFaktur }}</div>
                    <div class="smallText text-muted">{{ row.item.cabang }}</div>
                </template>
                <template v-slot:cell(tanggalGadai)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalGadai)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalGadai)}}</div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                        <p class="mb-0">{{row.item.jenisBarang.name}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merkBarang.name}} - {{row.item.tipeBarang.name}}</p>
                    </div>
                    <div v-else>
                        <p class="mb-0">{{row.item.jenisBarang.name}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merkBarang.name}} - {{row.item.tipeBarang.name}}</p>
                    </div>
                </template>
                <template v-slot:cell(namaAnggota)="row">
                    <p class="mb-0">{{row.item.namaAnggota}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.nomorAnggota}}</p>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'Pending'">PENDING</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'Approved'">DITERIMA</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'Rejected'">DITOLAK</b-badge>
                    <b-badge v-else>UNKNOWN</b-badge>
                    <p v-if="row.item.voidAfterPrint == true" class="mb-0 smallText text-muted">SUDAH CETAK</p>
                    <p v-else class="mb-0 smallText text-muted">BELUM CETAK</p>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="row.item.status != '-'" class="no-wrap">
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="gadaiViewBtn" @click="viewGadai(row.item.id)">
                            <i class="fa fa-info"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-detail-voidGadai" title="Detail Void Gadai" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TRANSAKSI</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                    <b-col v-if="detailVoidGadai.noFaktur != null"><strong>{{ detailVoidGadai.noFaktur }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang</b-col>
                    <b-col v-if="detailVoidGadai.cabang != null">{{ detailVoidGadai.cabang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col v-if="detailVoidGadai.status != null">{{ detailVoidGadai.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tanggal Gadai</b-col>
                    <b-col v-if="detailVoidGadai.tanggalGadai != null">{{$helper.changeDateFormat(detailVoidGadai.tanggalGadai)}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4 mt-4">
                <h6 class="form-title mb-2">ANGGOTA</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">No. Anggota</b-col>
                    <b-col>{{ detailVoidGadai.nomorAnggota }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Nama</b-col>
                    <b-col>{{ detailVoidGadai.namaAnggota }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA BARANG</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Jenis Barang</b-col>
                    <b-col v-if="detailVoidGadai.jenisBarang != null">{{ detailVoidGadai.jenisBarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Merk Barang</b-col>
                    <b-col v-if="detailVoidGadai.merkBarang != null">{{ detailVoidGadai.merkBarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tipe Barang</b-col>
                    <b-col v-if="detailVoidGadai.tipeBarang != null">{{ detailVoidGadai.tipeBarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">KETERANGAN</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diproses pada</b-col>
                    <b-col v-if="detailVoidGadai.processedAt != null">{{ $helper.changeDateFormat(detailVoidGadai.processedAt )}} {{ $helper.changeDateFormatGetHour(detailVoidGadai.processedAt )}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diproses oleh</b-col>
                    <b-col v-if="detailVoidGadai.processedBy != null">{{ detailVoidGadai.processedBy }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Ajuan</b-col>
                    <b-col v-if="detailVoidGadai.keteranganAjuan != null">{{ detailVoidGadai.keteranganAjuan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Approval</b-col>
                    <b-col v-if="detailVoidGadai.keteranganApproval != null">{{ detailVoidGadai.keteranganApproval }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Pembuat Gadai</b-col>
                    <b-col v-if="detailVoidGadai.pembuatGadai != null">{{ detailVoidGadai.pembuatGadai }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Void gadai belum diproses.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Void gadai diterima. Transaksi gadai dinyatakan VOID.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Void gadai ditolak. Transaksi gadai tidak digugurkan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">SUDAH CETAK</h6>
                <p class="smallText mb-0">Void gadai diajukan setelah eksekusi transaksi (sudah cetak SBG dan uang kas cabang sudah berubah).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">BELUM CETAK</h6>
                <p class="smallText mb-0">Void gadai diajukan sebelum eksekusi transaksi (belum cetak SBG, kas cabang belum berubah).</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'daftar-void-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterCabang: null,
                filterVoidStatus: null,
                filterFromDate: null,
                filterToDate: null,
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur & Cabang" },
                { key: "namaAnggota", label: "Anggota"},
                { key: "Barang", label: "Barang" },
                { key: "tanggalGadai", label: "Tanggal Gadai"},
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi" },
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            cabangOption: [],
            voidStatus: [
                {id: true, name: 'SUDAH CETAK'},
                {id: false, name: 'BELUM CETAK'}
            ],
            daftarGadai: [],
            detailVoidGadai: {},
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDaftarGadai = this.$axios.get("gadai/void/list/"+this.query).then(response => {
                this.daftarGadai = response.data.data
         
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getCabang, getDaftarGadai]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarGadai(){
            this.toggleBusy()
            this.daftarGadai = []

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterVoidStatus != null) this.query = this.query + "&filterVoidAfterPrint=" + this.input.filterVoidStatus
            
            this.$axios.get("gadai/void/list/"+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDaftarGadai()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarGadai()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterNoFaktur = null
            this.input.filterCabang = null
            this.input.filterVoidStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDaftarGadai()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getDaftarGadai()
            }
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        viewGadai(id){
            console.log(id)
            let idx = this.daftarGadai.findIndex(item => item.id == id);
            this.detailVoidGadai = this.daftarGadai[idx]
            this.$bvModal.show("modal-detail-voidGadai")
        },
    },

    created(){
        this.init()
    }
}
</script>
